module.exports = __webpack_public_path__ + "img/index11.ef69342a.png";